import { createFeature, createReducer, on } from '@ngrx/store';
import { DividendReInvestSettings } from '../entities/dividend-re-invest-settings.entity';
import { dividendReInvestActions, dividendReInvestApiActions } from './dividend-re-invest.actions';

export const DIVIDEND_RE_INVEST_KEY = 'dividend-re-invest';

interface DividendReInvestState {
  error: string;
  hasActivated: boolean;
  isVisible: boolean;
  hasOngoingRequest: boolean;
  hasChosen: boolean;
  currentSettings: DividendReInvestSettings;
}

const initialState: DividendReInvestState = {
  error: null,
  hasActivated: false,
  isVisible: true,
  hasOngoingRequest: false,
  hasChosen: false,
  currentSettings: null,
};

export const dividendReInvestFeature = createFeature({
  name: DIVIDEND_RE_INVEST_KEY,
  reducer: createReducer(
    initialState,
    on(dividendReInvestActions.decline, (state): DividendReInvestState => ({ ...state, hasOngoingRequest: true })),
    on(dividendReInvestActions.activate, (state): DividendReInvestState => ({ ...state, hasOngoingRequest: true })),
    on(dividendReInvestActions.close, (state): DividendReInvestState => ({ ...state, isVisible: false })),
    on(dividendReInvestApiActions.declineSuccess, (state): DividendReInvestState => ({ ...state, isVisible: false })),
    on(dividendReInvestApiActions.activateSuccess, (state): DividendReInvestState => ({ ...state, hasActivated: true })),
    on(
      dividendReInvestApiActions.declineSuccess,
      dividendReInvestApiActions.activateSuccess,
      (state, { settings }): DividendReInvestState => ({
        ...state,
        error: null,
        hasOngoingRequest: false,
        hasChosen: true,
        currentSettings: settings,
      }),
    ),
    on(
      dividendReInvestApiActions.activateFailed,
      dividendReInvestApiActions.declineFailed,
      (state, { error }): DividendReInvestState => ({
        ...state,
        error: error.message,
        hasOngoingRequest: false,
      }),
    ),
    on(
      dividendReInvestApiActions.loadCurrentSettingsSuccess,
      (state, { settings }): DividendReInvestState => ({ ...state, currentSettings: settings }),
    ),
  ),
});
